import {createGlobalStyle, css} from 'styled-components'

import {media} from '@/src/config/theme'

import {ContainerStyles, ContentMainStyles} from '@/src/shared/ui/layout/ui/content.styles'

const vitrineLegacyCss = css`
  @font-face {
    font-family:'FuturaPT';
    src:url("https://runlab.ru/i/fonts/FuturaPT-Light.eot?#iefix") format("embedded-opentype"),url("https://runlab.ru/i/fonts/FuturaPT-Light.woff") format("woff"),url("https://runlab.ru/i/fonts/FuturaPT-Light.ttf") format("truetype"),url("https://runlab.ru/i/fonts/FuturaPT-Light.svg#FuturaPT-Light") format("svg");
    font-weight:300;
    font-style:normal;
  }
  @font-face {
    font-family:'FuturaPT';
    src:url("https://runlab.ru/i/fonts/FuturaPT-Book.eot?#iefix") format("embedded-opentype"),url("https://runlab.ru/i/fonts/FuturaPT-Book.woff") format("woff"),url("https://runlab.ru/i/fonts/FuturaPT-Book.ttf") format("truetype"),url("https://runlab.ru/i/fonts/FuturaPT-Book.svg#FuturaPT-Book") format("svg");
    font-weight:normal;
    font-style:normal;
  }
  @font-face {
    font-family:'FuturaPT';
    src:url("https://runlab.ru/i/fonts/FuturaPT-Medium.eot?#iefix") format("embedded-opentype"),url("https://runlab.ru/i/fonts/FuturaPT-Medium.woff") format("woff"),url("https://runlab.ru/i/fonts/FuturaPT-Medium.ttf") format("truetype"),url("https://runlab.ru/i/fonts/FuturaPT-Medium.svg#FuturaPT-Medium") format("svg");
    font-weight:500;
    font-style:normal;
  }
  @font-face {
    font-family:'FuturaPT';
    src:url("https://runlab.ru/i/fonts/FuturaPT-Demi.eot?#iefix") format("embedded-opentype"),url("https://runlab.ru/i/fonts/FuturaPT-Demi.woff") format("woff"),url("https://runlab.ru/i/fonts/FuturaPT-Demi.ttf") format("truetype"),url("https://runlab.ru/i/fonts/FuturaPT-Demi.svg#FuturaPT-Demi") format("svg");
    font-weight:600;
    font-style:normal;
  }
  body {
    font-size:100%;
    line-height:160%;
    background:#fff;
    font-family:FuturaPT,sans-serif;
    color:#000;
  }
  
  body {
    height: 100%;
  }

  body {
    font-family: FuturaPT,sans-serif;
    font-size: 15px;
    line-height: 120%;
    color: #000;
    background: #000;
    -webkit-overflow-scrolling: touch;
  }

  body {
    top: 0 !important;
  }

  html {
    height: 100%;
  }

  html {
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
  }

  .vitrine {
    display: table;
    width: 100%;
    font-size: 0;
    line-height: 0;
    text-align: justify;
  }

  .vitrine  {
    margin-top: 20px;
  }

  .vitrine:after, .vitrine .items::after {
    content: '';
    display: inline-block;
    width: 100%;
  }

  .product  {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    width: 25%;
  }

  .product  {
    padding: 15px 25px 20px 28px;
    margin-bottom: 35px;
    position: relative;
    border: 1px solid transparent;
    text-align: left;
  }

  .product  {
    width: 100%;
  }
  
  @media ${media.sm} {
    .product  {
      width: 45%;
      max-width: 280px;
    }
  }

  .product:hover  {
    border-color: #c2c2c2;
    z-index: 101;
  }

  a {
    color: #ff9829;
  }

  .product-link-overlay  {
    position: absolute !important;
    left: 0;
    top: 0;
    z-index: 100 !important;
    width: 100%;
    height: calc(100% - 62px);
  }

  .vitrine .product > a  {
    position: relative;
    z-index: 1;
  }

  a:hover {
    color: #ffcc08;
  }

  .product-image  {
    display: block;
    height: 210px;
    line-height: 210px;
    text-align: center;
    position: relative;
    margin-bottom: 15px;
  }

  .product-name-block  {
    margin-bottom: 13px;
  }

  .product-short-description  {
    font-size: 16px;
    font-weight: 300;
    line-height: 1.2;
    margin-bottom: 19px;
  }

  img {
    border: 0;
    -ms-interpolation-mode: bicubic;
    vertical-align: middle;
  }

  .product-image img  {
    max-width: 100%;
    max-height: 100%;
  }

  .gen-JBh-wrapperart {
    max-width: 100%;
    height: auto !important;
  }

  .product-image .alternate-image  {
    display: none;
  }

  .product:hover .alternate-image  {
    display: inline;
  }

  .product:hover .alternate-image + img  {
    display: none;
  }

  .product-link  {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .product-link a  {
    text-decoration: none;
    color: #000;
  }



`

export const StaticBasicStyles = css`
  ${vitrineLegacyCss}
  
  line-height: 120%;

  h1 {
    font-size: 44px;
    line-height: 120%;
  }

  h1,
  h1 a,
  .h1,
  .h1 a,
  h2,
  h2 a,
  .h2,
  .h2 a {
    font-weight: 500;
    margin-bottom: 15px;
    text-decoration: none;
  }

  h2,
  h3,
  h4 {
    font-size: 21px;

    @media ${media.md} {
      font-size: 30px;
    }
  }

  h2,
  h3,
  h4,
  h5 {
    border: unset !important;
    text-shadow: unset !important;

    padding-top: 20px;

    font-weight: 500;
    line-height: 120%;
    margin-bottom: 15px;
    text-decoration: none;
  }

  p {
    text-align: justify;
    padding-top: 10px;

    line-height: 160%;
  }

  table {
    margin-top: 10px;
  }

  ul:not(.product-list-snippet) {
    margin: 10px 0;
  }

  ul:not(.product-list-snippet) li {
    position: relative;
    padding-top: 0;
    line-height: 1.2 !important;

    font-size: 16px;
    margin-bottom: 10px;
    padding-left: 25px;

    &:before {
      width: 11px;
      height: 11px;

      content: '';
      position: absolute;
      left: 0;
      top: 5px;
      border-radius: 50%;
      background-color: #ffcc08;
    }
  }

  .btn {
    display: block;
    color: black;
    padding: 16px;
    background: #ffcc08;
    text-align: center;
    border-radius: 5px;
  }

  .btn:hover {
    color: white;
  }

  .btn.dark {
    color: white;
    background: black;
  }

  .btn.dark:hover {
    color: #ffcc08;
  }

  .w-100 {
    width: 100%;
  }

  .title {
    padding-top: 10px;
  }

  .title-2 {
    font-size: 1.25rem;
    font-weight: 450;
  }

  .title-3 {
    font-size: 1rem;
    font-weight: 450;
  }
  

`


export const StaticPageCss = css`
  .static {
    .delivery-table {
      width: 100%;
      font-size: 16px;
      line-height: 120%;
    }

    @media only screen and (max-width: 480px) {
      .delivery-table {
        font-size: 14px;
      }
    }

    .delivery-table th,
    .delivery-table td {
      padding: 5px 10px;
    }

    .delivery-table th {
      white-space: nowrap;
      font-size: 15px;
      line-height: 120%;
      color: #8a8a8a;
      border-bottom: 1px solid #ffcc08;
      font-weight: normal;
      text-align: left;
    }

    @media only screen and (max-width: 480px) {
      .delivery-table th {
        white-space: normal;
        font-size: 14px;
      }
    }

    .delivery-table tr th:first-child,
    .delivery-table tr td:first-child {
      padding-left: 0;
    }

    .delivery-table tr th:last-child,
    .delivery-table tr td:last-child {
      padding-right: 0;
    }

    .delivery-table tr td {
      border-bottom: 1px solid #dcdcdc;
    }

    .delivery-table tr.noborder td {
      border-bottom: none;
    }

    .delivery-table.single-table {
      font-size: 15px;
      line-height: 120%;
    }

    .delivery-table.single-table th {
      color: #000;
    }
  }
`


export const StaticStyles = createGlobalStyle`
  ${StaticPageCss}
  
  .static-container {
    align-self: center;
    ${StaticBasicStyles}
  }

  ${ContentMainStyles}
  ${ContainerStyles}

`
